/* eslint-disable */
/* eslint-disable func-names */
/* eslint-disable no-prototype-builtins */
/* eslint-disable consistent-return */
/* eslint-disable no-restricted-syntax */
import moment from 'moment';
import provinces from './provinces.json';
import countryCodes from './countryCodes.json';

const isUserLoggedIn = () => localStorage.getItem('token');

const classNames = (...classes) => classes.filter(Boolean).join(' ');

const fixedDigitNumber = (num, digits = 4) => (num).toLocaleString('en-US', { minimumIntegerDigits: digits, useGrouping: false });

const formatUSPhoneNumber = (phoneNumberString) => {
  const cleaned = (`${phoneNumberString}`).replace(/\D/g, '');
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`;
  }
  return phoneNumberString || null;
};

function objectDiff(a, b) {
  const obj = JSON.parse(JSON.stringify(a));
  Object.keys(obj).forEach((key) => {
    if (typeof obj[key] === 'object' && JSON.stringify(obj[key]) === JSON.stringify(b[key])) delete obj[key];
    if (obj[key] === b[key]) delete obj[key];
  });
  return obj;
}

const timezonesList = [
  { name: 'Eastern Standard Time (EST)', value: '1' },
  { name: 'Central Standard Time (CST)', value: '2' },
  { name: 'Pacific Standard Time (PST)', value: '3' },
  { name: 'Mountain Standard Time (MST)', value: '4' },
  { name: 'Hawaii–Aleutian Standard Time (HST)', value: '5' },
  { name: 'Alaska Standard Time (AKST)', value: '6' },
];

const gendersList = [
  { name: 'Male', value: 'male' },
  { name: 'Female', value: 'female' },
  { name: 'Non-binary', value: 'non-binary' },
];

const parseJwt = (token = '') => {
  if (!token) return;
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(window.atob(base64).split('').map((c) => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`).join(''));
  return JSON.parse(jsonPayload);
};

const generateCSV = (csvData = [], filename = 'Report') => {
  let csvContent = 'data:text/csv;charset=utf-8,';

  csvData.forEach((rowArray) => {
    const row = rowArray.join(',');
    csvContent += `${row}\r\n`;
  });

  const encodedUri = encodeURI(csvContent);

  const link = document.createElement('a');
  link.setAttribute('href', encodedUri);
  link.setAttribute('download', filename);
  document.body.appendChild(link); // Required for FF

  link.click(); // This will download the data file named "my_data.csv".

  document.body.removeChild(link);
};

const getUserRole = () => parseJwt(localStorage.getItem('token'))?.role;
const getUserId = () => parseJwt(localStorage.getItem('token'))?.id;

const serializeQueryParams = function (obj, prefix) {
  const str = [];
  let p;
  for (p in obj) {
    if (obj.hasOwnProperty(p)) {
      const k = prefix ? `${prefix}[${p}]` : p;
      const v = obj[p];
      str.push((v !== null && typeof v === 'object')
        ? serializeQueryParams(v, k)
        : `${encodeURIComponent(k)}=${encodeURIComponent(v)}`);
    }
  }
  return str.join('&');
};

const colorCode = {
  scheduled: {
    hover: '#64E3B6',
    color: 'text-[#059D42] font-semibold',
  },
  cancelled: {
    hover: '#f25c5c',
    color: 'text-[#FF3459] font-semibold',
  },
  canceled: {
    hover: '#f25c5c',
    color: 'text-[#FF3459] font-semibold',
  },
  completed: {
    hover: '#FAE7B7',
    color: 'text-[#B58100] font-semibold',
  },
  noShow: {
    hover: '#DCDCDC',
    color: 'text-[#8C8C8C] font-semibold',
  },
  rescheduled: {
    hover: '#f78d23',
    color: 'text-primary-500 font-semibold',
  },

};

// color code with status

const statusColor = (status) => colorCode[status];

// Calendar Legends
const getCalendarLegend = (statusString = 'completed') => {
  switch (statusString) {
    case 'completed': return {
      color: 'bg-[#FAA92F]',
      hover: '[#f2d896]',
      text: 'text-white',
    };
    case 'cancelled': return {
      color: 'bg-[#F10000]',
      hover: '[#f74f4f]',
      text: 'text-white',

    };

    case 'canceled': return {
      color: 'bg-[#F10000]',
      hover: '[#f74f4f]',
      text: 'text-white',

    };
    case 'scheduled': return {
      color: 'bg-[#00B548]',
      hover: '[#000]',
      text: 'text-white',

    };
    case 'rescheduled': return {
      color: 'bg-[#f58a4c]',
      hover: 'bg-[#f28f2c]',
      text: 'text-white',

    };
    case 'noShow': return {
      color: 'bg-[#343434]',
      hover: '[#c2baba]',
      text: 'text-white',

    };
    default: return {
      color: 'blue-10',
      hover: 'blue-50',
      text: 'text-gray-900',

    };
  }
};

// get formatted role of provider
const providerRole = (role = 'doctor') => {
  const obj = {
    doctor: 'Doctor',
    wellness_coach: 'Wellness Coach',
    registered_professional: 'Registered Professional',
  };

  return obj[role];
};

const show12HourTime = (time) => moment()
  .set({ hour: time.split(':')[0], minute: time.split(':')[1], seconds: 0 })
  .format('hh:mm A');

const isSlotPassed = (time = '12:00', selectedDate = new Date()) => {
  const isSameDate = moment(selectedDate).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD');

  if (isSameDate) {
    const currentTime = moment().format('HH:mm');
    const isGreaterTime = !(time.split(':')[0] <= currentTime.split(':')[0]);
    return isGreaterTime;
  }

  return true;
};

// check if slot is clashing with events data
const isSlotOccupied = (startTime = '10:00', endTime = '11:00', d = '', arr = []) => {
  // TODO: remove the suffix for timezone from calendar

  let notOccupied = true;
  const sTime = moment(d)
    .set({ hour: startTime.split(':')[0], minute: startTime.split(':')[1], seconds: 0 });
  const eTime = moment(d)
    .set({ hour: endTime.split(':')[0], minute: endTime.split(':')[1], seconds: 0 });

  let eventTimings = [];

  if (arr && arr.length > 0) {
    eventTimings = arr.map((el) => ({
      start: {
        ...el.start,
        mDate: moment(el.start.dateTime).format('hh:mm'),
      },
      end: {
        ...el.end,
        mDate: moment(el.end.dateTime).format('hh:mm'),
      },
    }));
  }

  if (eventTimings.length > 0) {
    eventTimings.forEach((el) => {
      // excluded the time zone prefix from datestring
      const start = moment(el.start.dateTime.slice(0, 19));
      const end = moment(el.end.dateTime.slice(0, 19));

      if (moment(sTime).isBetween(start, end)
       || moment(eTime).isBetween(start, end)) { notOccupied = false; }
    });
  }

  return notOccupied;
};

const checkDateIsFuture = (dateString) => moment().format('YYYY-MM-DD') === dateString || moment(dateString).isAfter(moment());

const validWeekDays = (startDate, endDate, daysAvailable = []) => {
  const diff = moment(endDate).diff(moment(startDate), 'days');

  let sDate = moment(startDate);

  let isValid = true;

  if (diff >= 1 && diff <= 7) {
    let dates = [];
    while (moment(sDate) <= moment(endDate)) {
      dates.push(sDate);
      sDate = moment(sDate).add(1, 'days').format('YYYY-MM-DD');
    }

    dates = dates.map((d) => moment(d).format('dddd').substring(0, 3).toUpperCase());

    // check if selected weekDays consist of actual weekDays
    daysAvailable.forEach((day) => {
      if (!dates.includes(day)) {
        isValid = false;
      }
    });
  }

  return isValid;
};

// slot duration function
const calculateSlotDuration = (slot) => {
  const startStr = `${slot.dateString}T${slot.startTime}:00`;
  const endStr = `${slot.dateString}T${slot.endTime}:00`;

  // start time and end time
  const startTime = moment(startStr);
  const endTime = moment(endStr);

  // console.log('startTime', startTime);

  // calculate total duration
  const duration = moment.duration(endTime.diff(startTime)).asMinutes();

  return duration;
};

export {
  isUserLoggedIn,
  classNames,
  fixedDigitNumber,
  formatUSPhoneNumber,
  objectDiff,
  provinces,
  countryCodes,
  timezonesList,
  gendersList,
  getUserId,
  getUserRole,
  serializeQueryParams,
  generateCSV,
  statusColor,
  getCalendarLegend,
  show12HourTime,
  providerRole,
  isSlotPassed,
  isSlotOccupied,
  calculateSlotDuration,
  checkDateIsFuture,
  validWeekDays,
};
